import styled from "styled-components";

export const StyledTelegramChannelWrapper = styled.div`
  margin: 3px 3px 0;
  padding: 30px 15px;
  background-color: rgba(245, 244, 250, 0.25);
  box-shadow: 0 2px 4px #c4c4c4;
  border-radius: 16px;
  transition: all .15s ease .15s;

  .telegram-logo {
    text-align: center;
    a {
      width: 122px;
      height: 122px;
      display: inline-block;
      border-radius: 61px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }

  .telegram-title {
    padding: 15px 0;
    color: #162954;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    @media screen and (max-width: 576px) {
      font-size: 18px;
    }
  }

  .telegram-description {
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }

  .telegram-action {
    padding-top: 20px;
    text-align: center;
    a {
      height: 42px;
      padding: 13px 24px;
      color: #FFF;
      font-size: 16px;
      font-weight: 700;
      line-height: 17px;
      background: #2481cc linear-gradient(270deg, rgba(100, 181, 239, 0) 48.44%, #64b5ef 75.52%, rgba(100, 181, 239, 0) 100%) no-repeat;
      border-radius: 22px;
      overflow: hidden;
      display: inline-block;
      text-transform: uppercase;
      vertical-align: top;
      transition: all .3s ease;
      animation: bg-move linear 5s infinite;
      &:hover {
        background: #1a8ad5;
      }
    }

    @keyframes bg-move {
      0% {
        background-position: -500px 0;
      }
      100% {
        background-position: 1000px 0;
      }
    }
  }
`;